import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
// eslint-disable-next-line import/no-extraneous-dependencies
import { from } from 'rxjs';
// eslint-disable-next-line import/no-extraneous-dependencies
import { map } from 'rxjs/operators';

import { imageTypes } from '@Constants/rx-ui/constants';

import RxThumbnail from '@Services/RxThumbnail';

import ImageBase64 from '@Components/ImageBase64';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import Button from '@Components/Button';

import * as FormatUtils from '@Services/FormatUtils';

import './AlertStructuresButton.custom.scss';
import './AlertStructuresButton.theme.scss';

export function spinnerOrImage({ src }) {
  if (!src) {
    return (
      <SimpleSpinner className="alert-structures-button--spinner" spinnerAnimationClassName="alert-structures-button--spinner-animation" />
    );
  }

  return <img src={src} alt="alert structures" className="alert-structures-button--image" />;
}

export function mapAlertThumbnail(result) {
  const thumbnail = result[imageTypes.ALERT_THUMBNAIL];

  if (!thumbnail) {
    return '';
  }

  const { url } = thumbnail;
  const formatedUrl = FormatUtils.formatPath(url);

  return formatedUrl;
}

export function useUrl(props) {
  const [url, setUrl] = useState('');

  const { structureInfo } = props;
  useEffect(() => {
    const structure = structureInfo.get('structure');

    const request = RxThumbnail.memoFetAlertThumbnail(structure);
    const fullImageUrl$ = from(request).pipe(map(mapAlertThumbnail));
    const subscription = fullImageUrl$.subscribe(setUrl);

    return () => {
      subscription.unsubscribe();
    };
  }, [structureInfo]);

  return url;
}

export default function AlertStructuresButton(props) {
  const url = useUrl(props);
  const { openStructureDialog, id, structureInfo } = props;

  const onClick = useCallback(() => {
    const structure = structureInfo.get('structure');

    openStructureDialog(id, structure);
  }, [openStructureDialog, id, structureInfo]);

  return (
    <Button
      buttonConfig={{
        size: 'sm',
        tabIndex: 0,
        className: 'alert-structures-button',
        e2eName: 'alert-structures',
        ariaLabel: 'Alert structures',
      }}
      onClick={onClick}>
      <span className="alert-structures-button--inner">
        <ImageBase64 src={url}>{spinnerOrImage}</ImageBase64>
      </span>
    </Button>
  );
}

AlertStructuresButton.propTypes = {
  id: PropTypes.string.isRequired,
  structureInfo: PropTypes.instanceOf(Map).isRequired,
  openStructureDialog: PropTypes.func.isRequired,
};
